/**
 * <s-sticky-atc> — bottom add-to-cart bar for the product page.
 *
 * Attributes:
 *   watch — id of the element whose visibility hides the bar (the main product form).
 *
 * Shows the bar (data-visible) once the watched element has scrolled above the viewport,
 * and keeps the bar's hidden input[name="id"] in sync with its variant select so the
 * wrapping <s-product-form> adds the chosen variant.
 */
class SStickyAtc extends HTMLElement {
  #ac;
  #observer;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    const select = this.querySelector('select[data-sticky-variant]');
    const idInput = this.querySelector('input[name="id"]');
    if (select instanceof HTMLSelectElement && idInput instanceof HTMLInputElement) {
      select.addEventListener('change', () => {
        idInput.value = select.value;
      }, opts);
    }

    const watched = document.getElementById(this.getAttribute('watch') || '');
    if (!watched || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', scrolledPast);
      this.inert = !scrolledPast;
    });
    this.inert = true;
    this.#observer.observe(watched);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', SStickyAtc);
}
